import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Updated:',
  breadcrumbs: {
    home: 'Home',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Why you can trust us',
        details: {
          text: '<h2>Why you can trust us</h2><p>Articles on Natu.Care are written based on scientific research, data from government websites and other reliable sources. The texts are written in cooperation with doctors, nutritionists and other health and beauty experts. Articles are reviewed before publication and during significant updates.</p>.',
          footerText: '<p>Learn more about our <a href="/uk/about-us/editorial-process">editorial process</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Information on advertisements',
        details: {
          text: '<h2>Information about advertisements</h2><p>Content on Natu.Care may contain links to products from the sale of which we may receive a commission. When creating content, we adhere to high editorial standards and take care to be objective about the products discussed. The presence of affiliate links is not dictated by our partners, and we select the products we review ourselves completely independently.</p>.',
          footerText: '<p>Learn more about our <a href="/uk/terms-of-service">terms and Conditions</a></p>.',
        }
      }
    ],
    tooltip: {
      labelVerified: 'Verified by an expert',
      footerText: '<p>Learn more about our <a href="/uk/about-us/editorial-process">editorial process</a></p>.'
    }
  },

  mediabar: {
    heading: 'Media about us:',
    href: '/uk/about',
    title: 'Media about us:',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Take care of a healthy body',
    description: `Try Natu.Care's high-quality supplements`,
    button: {label: 'See products', href: 'https://natu.shop/collections'},
    picture: {alt: 'Young, beautiful women with good skin condition'}
  },

  authorship: {
    heading: 'Editorials',
    link: {
      label: 'Meet the team',
      href: '/uk/about-us/editorial-team'
    }
  },

  similarArticles: {
    headingBlogList: 'Articles',
    headingBlogPost: 'Similar articles'
  }  
};
